import React from 'react';
import { portfolioData } from '../data/mock';
import { MapPin, Mail } from 'lucide-react';

const AboutSection = () => {
  const { personal, education } = portfolioData;

  return (
    <section id="about" className="py-20 px-4 sm:px-6 lg:px-8 bg-[#1a1d29]">
      <div className="max-w-5xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            <span className="text-emerald-400 font-mono text-xl">01.</span> About Me
          </h2>
          <div className="h-px bg-gray-700 mt-4"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <p className="text-gray-300 text-lg leading-relaxed mb-6">
              {personal.summary}
            </p>
            <p className="text-gray-400 leading-relaxed">
              I'm Tilak (Tilakraj Desai), and throughout my career at companies like Emergent, Zepto, and Groww, 
              I've built and scaled infrastructure handling massive telemetry volumes. At tilakraj.cv, I share my 
              expertise in creating cost-effective, highly available solutions that empower development teams and 
              optimize operational efficiency.
            </p>
          </div>

          <div className="space-y-4">
            <div className="bg-[#0f1419] p-6 rounded-lg border border-gray-800">
              <h3 className="text-white font-semibold mb-4">Contact Info</h3>
              <div className="space-y-3 text-gray-400 text-sm">
                <div className="flex items-start gap-3">
                  <MapPin size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                  <span>{personal.location}</span>
                </div>
                <div className="flex items-start gap-3">
                  <Mail size={18} className="text-emerald-400 mt-0.5 flex-shrink-0" />
                  <a href={`mailto:${personal.email}`} className="hover:text-emerald-400 transition-colors break-all">
                    {personal.email}
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-[#0f1419] p-6 rounded-lg border border-gray-800">
              <h3 className="text-white font-semibold mb-2">{education.degree}</h3>
              <p className="text-emerald-400 text-sm mb-1">{education.institution}</p>
              <p className="text-gray-400 text-sm">{education.period}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
